module.exports = __webpack_public_path__ + "b3inventory.7779cf2d32f75315546c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/yardobject/font/b3inventory.svg?14714644
// module id = 693
// module chunks = 3